import { createTheme, withStyles } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    text: {
      primary: "#1d262c",
    },
    primary: {
      main: "#4453E2",
    },
  },
  spacing: (factor) => 4 * factor,
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: ["Poppins"].join(","),
    htmlFontSize: 16,
  },
});

export const GlobalCss = withStyles((theme) => ({
  "@global": {
    ":root": {
      "--color-text-primary": theme.palette.text.primary,
    },
  },
}))(() => null);

export default theme;
